import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DescriptionList } from '@printdeal/ui-library';
import { getActiveArtworkServices, hasLinkedServices } from '@printdeal/business-logic';

import { Money } from '../../../../Money';
import { SanitizedLineItem } from '../../../../../types/order/Order';
import OrderDetailContext from '../../contexts/OrderDetailContext';
import { Environment } from '../../../../../helpers/env';

interface LineItemDescriptionProps {
  lineItem: SanitizedLineItem;
}

const ArtServiceDescription = ({
  lineItem,
}: LineItemDescriptionProps) => {
  const intl = useIntl();
  const intlAbbreviation = intl.locale.slice(0, 2);
  const { order } = useContext(OrderDetailContext);

  if (!order) return null;

  if (!hasLinkedServices(lineItem.id, order)) {
    return null;
  }

  return (
    <>
      {
        getActiveArtworkServices(lineItem.id, order, Environment).map((service) => (
          <DescriptionList className="pd-mb-2 md:pd-grid-cols-3">
            <DescriptionList.Title>
              <FormattedMessage
                id="account.order.productDescription.service"
                defaultMessage="Service"
              />:
            </DescriptionList.Title>
            <DescriptionList.Content
              className="md:pd-col-span-2"
            >
              { service.name[intlAbbreviation] ?? service.custom.fields.serviceName }
              {' ('}
              <Money
                value={service.totalPrice.centAmount}
                currency={service.totalPrice.currencyCode}
              />
              )
            </DescriptionList.Content>
          </DescriptionList>
        ))
      }
    </>
  );
};

export default ArtServiceDescription;
